import { useDropzone } from "react-dropzone";

export const CostFileUpload = (props) => {
  const {onDrop, acceptedFiles, fileRejections} = props;

  const { getRootProps, getInputProps } =
    useDropzone({
      onDrop,
      maxFiles: 1,
      maxSize: 5242880,
      accept: {
        "application/vnd.ms-excel": [".xls"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]
      },
      multiple: false,
    });

  const files = acceptedFiles.map((file) => (
    <div key={file.path} className="text-sm mt-1.5">
      <li >
        {file.name} - {file.size} bytes
      </li>
    </div>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => {
    return (
      <div key={file.path} className="text-sm mt-1.5">
        <li>
          {file.name} - {file.size} bytes
          <ul>
            {errors.map((e) => (
              <li key={e.code}>{e.message}</li>
            ))}
          </ul>
        </li>
      </div>
    );
  });

  return (
    <>
      <div className="text-sm flex flex-col items-center mt-[5px] p-[4px] border-2 rounded-sm  border-dashed border-lb-file-up-border-color bg-lb-file-up-background text-lb-file-up-font-color outline-none cursor-pointer transition-all duration-[0.24s] ease-in-out">
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          <p className="text-sm my-3">Drag 'n' drop a file here, or click to select a file</p>
        </div>
     
      </div>
      <aside>
        <p className="text-sm mt-6">Files</p>
        <ul>{files}</ul>
        <p className="text-sm mt-6">Rejected Files</p>
        <ul>{fileRejectionItems}</ul>
      </aside>
    </>
  );
};
